import React from "react";
import { Control, FormState, Controller } from "react-hook-form";
import { DenseTextField } from '../../../Themes/StyledElements';
import { Grid, Typography } from "@material-ui/core";

// Fonction pour accéder aux erreurs imbriquées
const getNestedError = (errors: any, name: string) => {
    // Convertir le nom du champ en tableau de clés
    // Par exemple, "spot.productNature" devient ["spot", "productNature"]
    // "works.[0].workCode" devient ["works", "0", "workCode"]
    const keys = name.replace(/\.\[/g, '.').replace(/\]/g, '').split('.');

    // Parcourir l'objet d'erreurs en suivant le chemin des clés
    let current = errors;
    for (const key of keys) {
        if (!current || !current[key]) {
            return undefined;
        }
        current = current[key];
    }

    return current.message;
};

export const FormDateTimeField = ({ label, name, control, disabled, formState, required, helperText }: { label: string, name: string, control: Control, disabled?: boolean, formState: FormState<any>, required?: boolean, helperText?: string }) => {
    // Récupérer le message d'erreur pour ce champ
    const errorMessage = getNestedError(formState.errors, name);

    return (
        <Grid item container style={{ marginTop: '15px' }}>
            <Grid item xs={2}>
                {label} {required && <span style={{ color: 'red' }}>*</span>}
            </Grid>
            <Grid item xs={10} style={{ paddingRight: '20px' }}>
                <Controller
                    control={control}
                    name={name}
                    defaultValue=""
                    render={(field, state) => {
                        const { value, onChange } = field
                        const { invalid } = state

                        return (
                          <DenseTextField
                            value={value || ''}
                            onChange={onChange}
                            error={!!errorMessage}
                            disabled={disabled}
                            helperText={errorMessage}
                            required={required}
                            fullWidth
                            variant="outlined"
                            type="datetime-local"
                          />
                        );
                    }}
                />
                {!errorMessage && helperText && <Typography variant="caption" color="textSecondary">{helperText}</Typography>}
            </Grid>
        </Grid>
    )
}